import React from "react";
import "./analytics.css";
import StudentChart from "./../students-chart";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import InviteChart from "./../invite-chart";
import DateRangePicker from "./../date-range-picker";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import SemiCircleProgressBar from "react-progressbar-semicircle";
let Analytics = (props) => {
  let TableData = [
    {
      date: "JAN 4, 2022",
      name: "Sallie Gulgowski",
      country: "burnside",
      cource: "2",
      price: "$200",
    },
    {
      date: "JAN 4, 2022",
      name: "Sallie Gulgowski",
      country: "burnside",
      cource: "2",
      price: "$200",
    },
    {
      date: "JAN 4, 2022",
      name: "Sallie Gulgowski",
      country: "burnside",
      cource: "2",
      price: "$200",
    },

    {
      date: "JAN 4, 2022",
      name: "Sallie Gulgowski",
      country: "burnside",
      cource: "2",
      price: "$200",
    },
    {
      date: "JAN 4, 2022",
      name: "Sallie Gulgowski",
      country: "burnside",
      cource: "2",
      price: "$200",
    },
    {
      date: "JAN 4, 2022",
      name: "Sallie Gulgowski",
      country: "burnside",
      cource: "2",
      price: "$200",
    },
    {
      date: "JAN 4, 2022",
      name: "Sallie Gulgowski",
      country: "burnside",
      cource: "2",
      price: "$200",
    },
    {
      date: "JAN 4, 2022",
      name: "Sallie Gulgowski",
      country: "burnside",
      cource: "2",
      price: "$200",
    },
    {
      date: "JAN 4, 2022",
      name: "Sallie Gulgowski",
      country: "burnside",
      cource: "2",
      price: "$200",
    },
    {
      date: "JAN 4, 2022",
      name: "Sallie Gulgowski",
      country: "burnside",
      cource: "2",
      price: "$200",
    },
  ];
  return (
    <div>
      <h1 className="analytics-header-teacher-name">{props.teacherName}</h1>
      <div className="analytics-graph-main">
        <div className="graph-filter-main">
          <p className="analytics-graph-heading">{props.firstChartHeading}</p>
          <div className="analytics-graph-filter-header">
            <p className="analytics-graph-header-date">Jan-2022</p>
            <select className="analytics-graph-filter-dropdown">
              <option value="Monthly">Monthly</option>
              <option value="Weekely">Weekely</option>
              <option value="Yearly">Yearly</option>
            </select>
          </div>
        </div>
        <StudentChart firstChartHeading={props.firstChartHeading} />
      </div>

      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2}>
          <Grid item xl={8} lg={12} md={12} sm={12} xs={12}>
            <div className="analytics-graph-main">
              <div className="graph-filter-main">
                <p className="analytics-graph-heading">
                  {props.secondChartHeading}
                </p>
                <div className="analytics-graph-filter-header">
                  <p className="analytics-graph-header-date">Jan-2022</p>
                  <select className="analytics-graph-filter-dropdown">
                    <option value="Monthly">Monthly</option>
                    <option value="Weekely">Weekely</option>
                    <option value="Yearly">Yearly</option>
                  </select>
                </div>
              </div>
              <InviteChart secondChartHeading={props.secondChartHeading} />
            </div>
          </Grid>
          <Grid item xl={4} lg={12} md={12} sm={12} xs={12}>
            <div className="analytics-graph-main">
              <div className="graph-filter-main">
                <p className="analytics-graph-heading">
                  {props.thirdCharHeading}
                </p>
                <div className="analytics-graph-filter-header">
                  <select className="analytics-graph-filter-dropdown">
                    <option value="Monthly">Monthly</option>
                    <option value="Weekely">Weekely</option>
                    <option value="Yearly">Yearly</option>
                  </select>
                </div>
              </div>

              <div className="analytics-time-table-circle-progressbar">
                <SemiCircleProgressBar
                  stroke="#663399"
                  strokeWidth={40}
                  background="#F1F1F1"
                  showPercentValue={false}
                  percentage={70}
                  diameter={350}
                />
                <p className="analytics-time-table-circle-progressbar-heading">
                  Earning
                </p>
                <p className="analytics-time-table-circle-progressbar-price">
                  $3000
                </p>
              </div>
            </div>
          </Grid>
        </Grid>
      </Box>
      <br />
      <br />
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2}>
          <Grid item xl={9} lg={9} md={9} sm={7} xs={12}>
            <DateRangePicker />
          </Grid>
          <Grid item xl={3} lg={3} md={3} sm={5} xs={12}>
            <div className="analytics-graph-header">
              <p className="analytics-graph-header-date">Jan-2022</p>
              <select className="analytics-graph-filter-dropdown">
                <option value="Monthly">Monthly</option>
                <option value="Weekely">Weekely</option>
                <option value="Yearly">Yearly</option>
              </select>
            </div>
          </Grid>
        </Grid>
      </Box>
      <br />
      <div className="table-container">
        <div className="table-data-container">
          <table>
            <tr>
              <th className="analytics-time-table-table-date-heading">date</th>
              <th className="analytics-time-table-table-lecture-heading">
                Lecture 1
              </th>
              <th className="analytics-time-table-table-lecture-heading">
                Lecture 2
              </th>
              <th className="analytics-time-table-table-lecture-heading">
                Lecture 3
              </th>
              <th className="analytics-time-table-table-lecture-heading">
                Lecture 4
              </th>
              <th className="analytics-time-table-table-lecture-heading">
                Lecture 5
              </th>
              <th className="analytics-time-table-table-lecture-heading">
                Lecture 6
              </th>
            </tr>
            {TableData.map((tableValue, tableIndex) => {
              return (
                <tr key={tableIndex}>
                  <td className="table-data">{tableValue.date}</td>
                  <td className="table-data">Class 1A, Maths</td>
                  <td className="table-data">Class 1A, Maths</td>
                  <td className="table-data">Class 1A, Maths</td>
                  <td className="table-data">Class 1A, Maths</td>
                  <td className="table-data">Class 1A, Maths</td>
                  <td className="table-data">Class 1A, Maths</td>
                </tr>
              );
            })}
          </table>
        </div>
        <div className="table-pagination-main">
          <Stack spacing={2}>
            <Pagination count={10} variant="outlined" shape="rounded" />
          </Stack>
        </div>
      </div>
    </div>
  );
};
export default Analytics;
